import React from 'react'
import { useTranslation } from 'react-i18next';
import LoginForm, { loginForm } from '../../components/auth/LoginForm';
import { Alert, Box, Card, Container, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { routes } from '../routes';
import RegisterForm, { registerForm } from '../../components/auth/RegisterForm';
import { useAuth } from '../../hooks/useAuth';
import { AxiosError } from 'axios';
import { ApiError } from '../../shared/types/apiError.type';
import Errors from '../../components/global/Errors';
import LanguageSelector from '../../components/global/LanguageSelector';
import { languages } from '../../enums/languages.enum';
import i18next from 'i18next';
import { useLocales } from '../../hooks/useLocales';

function Register() {
  const { t } = useTranslation();
  const { register, isLoading, isError, error } = useAuth()
  const err = error?.response?.data as ApiError
  const { updateLang, currentLang } = useLocales()
  const navigation = useNavigate()

  const handleRegister = async (data: loginForm) => {
    try {
      let user = await register(data)
      if (!user) throw new Error('User not found')
      navigation(routes.AUTH_ROUTES.EMAIL_SENT, { state: { email: user.email } })
    } catch (error) {

    }
  }

  return (
    <Grid container minHeight={'100vh'} position={'relative'}>
      <Container maxWidth="lg" sx={{ pt: 2, display: 'flex', justifyContent: 'end' }}>
        <LanguageSelector
          langs={languages}
          onSelect={(lang) => { updateLang(lang) }}
          currentLang={currentLang}
        />
      </Container>
      <Grid item md={12} sm={12} xs={12} display={'flex'} justifyContent={'center'} alignItems={'start'} pb={4} >
        <Container maxWidth="md">
          <Errors isError={isError} error={err}></Errors>

          <RegisterForm isLoading={isLoading} onLoginClicked={() => navigation(routes.AUTH_ROUTES.LOGIN)} onRegisterSubmit={handleRegister}></RegisterForm>
        </Container>
      </Grid>
    </Grid>
  )
}

export default Register